import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "lucide-react";
import PagesEndpoints from "../../utilities/constants/PagesEndpoints";

const CallToAction = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-24 bg-blue-600 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg
          className="w-full h-full"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="white" />
        </svg>
      </div>

      <div className="container mx-auto px-6 max-w-5xl relative z-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/50 text-blue-100 text-sm font-medium mb-8 border border-blue-400">
          <CalendarCheck size={16} />
          <span>Limited availability for upcoming season</span>
        </div>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 font-serif tracking-tight">
          Ready to Host an Unforgettable Event?
        </h2>

        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto leading-relaxed">
          Check availability instantly and secure your date online. Our team is
          ready to bring your vision to life.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              navigate(PagesEndpoints.BOOKING_PAGE_URL);
            }}
            className="px-8 py-4 bg-white text-blue-600 rounded-full font-bold text-lg hover:bg-blue-50 transform hover:-translate-y-1 transition-all shadow-lg shadow-blue-900/20 flex items-center justify-center gap-2"
          >
            Book Your Date <ArrowRight className="w-5 h-5" />
          </button>

          <button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              navigate(PagesEndpoints.CONTACT_PAGE_URL);
            }}
            className="px-8 py-4 bg-transparent border-2 border-blue-400 text-white rounded-full font-bold text-lg hover:bg-blue-700 hover:border-blue-700 transition-all"
          >
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
